import PropTypes from 'prop-types';
import {Button, Modal} from 'semantic-ui-react';

function SuccessModal(props) {
  return (
    <Modal
      closeIcon
      closeOnEscape={false}
      closeOnDimmerClick={false}
      open={props.open}
      onClose={props.onClose}
      size={props.size}
    >
      <Modal.Header>بسته مشاوره</Modal.Header>
      <Modal.Content>
        <p className='text-large'>{props.message}</p>
      </Modal.Content>
      <Modal.Actions>
        <Button
          positive
          size='large'
          content='متوجه شدم'
          onClick={props.onConfirm}
        />
      </Modal.Actions>
    </Modal>
  );
}

SuccessModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onConfirm: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  size: PropTypes.string.isRequired
};

SuccessModal.defaultProps = {size: 'small'};

export default SuccessModal;
